// User / Authentication

export const authEndpoints = {
  login: "api/auth/login",
  logout: "api/auth/logout",
  creds: "api/auth/creds",
  currentuser: "api/auth/currentuser",
  refreshtoken: "api/auth/token/refresh",
  forgotpassword: "api/auth/forgotpassword",
  passwordchange: "api/auth/passwordchange",
};

export const customerEndpoints = {
  location: "api/c/location/",
  flow: "api/c/devices/flow/",
  hourlyflow: "api/c/devices/hourlyflow/",
  dailyflow: "api/c/devices/dailyflow/",
  monthlyflow: "api/c/devices/monthlyflow/",
  wallbox: "api/c/devices/wallbox/",
  heatpump: "api/c/devices/heatpump/",
  wallboxsetpoint: "api/c/devices/wallbox/setpoint/",
  wallboxlocktime: "api/c/devices/wallbox/locktime/",
  wallboxcharginghistory: "api/c/devices/wallbox/charginghistory/",
  wallboxcharginghistorystats: "api/c/devices/wallbox/charginghistorystats/",
  heatpumpsetpoint: "api/c/devices/heatpump/setpoint/",
  heatpumpsgreadyhistory: "api/c/devices/heatpump/sgreadyhistory/",
};

export const adminEndpoints = {
  client: "api/impulsclient/",
  assignclient: "api/impulsclient/assign/",
  configureclient: "api/impulsclient/configure/",
  clientsshtunnel: "api/impulsclient/sshtunnel/",
  clientrequestcounterheatmap: "api/impulsclient/requestcounterheatmap/",
  growattaccount: "api/growatt/",
  wallbox: "api/devices/wallbox/",
  heatpump: "api/devices/heatpump/",
  roof: "api/devices/inverter/roof/",
  wallboxsetpoint: "api/devices/wallbox/setpoint/",
  wallboxlocktime: "api/devices/wallbox/locktime/",
  wallboxcharginghistory: "api/devices/wallbox/charginghistory/",
  wallboxcharginghistorystats: "api/devices/wallbox/charginghistorystats/",
  heatpumpsetpoint: "api/devices/heatpump/setpoint/",
  heatpumpsgreadyhistory: "api/devices/heatpump/sgreadyhistory/",
  employee: "api/user/employee/",
  customer: "api/user/customer/",
  location: "api/location/",
  flow: "api/devices/flow/",
  hourlyflow: "api/devices/hourlyflow/",
  dailyflow: "api/devices/dailyflow/",
  monthlyflow: "api/devices/monthlyflow/",
};
